<template>
  <div :class="[companyName, 'company-custom']">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    companyName: {
      type: String,
      required: true,
    }
  },
  watch: {
    companyName: {
      handler: function() {
        this.$nextTick(() => {
          this.changeThemeColor()
        })
      },
      immediate: true,
    }
  },
  methods: {
    changeThemeColor() {
      // 键名对应公司标识
      // 具体公司对象键名对应company-custom.less中.company-custom的css变量名
      const themeMap = {
        'ZIJIN': {
          '--theme-color': '#5F2689',
          '--sub-color': '#F5F3FF',
        }
      }

      const companyRootEl = document.querySelector('.company-custom')
      const currentTheme = themeMap[this.companyName]
      if (companyRootEl && currentTheme) {
        // 根据不同公司改变css主题色变量
        for (let cssVar in currentTheme) {
          companyRootEl.style.setProperty(cssVar, currentTheme[cssVar]);
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/company-custom';
</style>